import { render } from "./Application11.vue?vue&type=template&id=0bf56977&scoped=true"
import script from "./Application11.vue?vue&type=script&lang=js"
export * from "./Application11.vue?vue&type=script&lang=js"

import "./Application11.vue?vue&type=style&index=0&id=0bf56977&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf56977"]])

export default __exports__